module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_6-cfb59129ff1fea462312c760d389afe9.jpg";